export const BASE = {
  company: {
    logo: "https://storage.googleapis.com/companies-assets/lyon/lyon_logo.png",
    background_image: "https://storage.googleapis.com/companies-assets/unico/unico_onboarding-bg.jpg",
    primaryColor: "#016940",
    secondaryColor: "#8f0028",
    tertiaryColor: "#541b10",
    copyrightLogo: "default",
    backgroundColor: ["#000000", "#000000"],
    tenant: 'unico-dgx7z',
    name: 'Lyon',
    bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
    id: '56bbc31f-40dd-47b4-b10d-39aae6a1ba81',
    dis: 0.87
  }
}